export default __webpack_public_path__ + "static/media/project9.69648f58.png";